const sanitizeHTML = word => word.replace(/[<>]/g, '')

const highlightWords = (searchText, word, shouldSanitize = false) => {
  const regex = new RegExp(`(${word.trim()})`, 'gi')
  const sanitizedText = shouldSanitize ? sanitizeHTML(searchText) : searchText
  return sanitizedText.replace(regex, '<b>$1</b>')
}

export const escapeRegexSpecialCharacters = word => word.replace(/[-[/\]{}()*+?.,\\^$|#]/g, '\\$&')
export default highlightWords
